module.exports = __webpack_public_path__ + "static/img/tooltip-geo-arc-protection.8e5972d.png";